<template>
  <div class="pb-20">
    <ul class="list-none">
      <li v-for="(filter, filterName) in filtersData" :key="filterName" class="pb-2.5 px-2 md:px-0 sm:px-6">
        <div v-if="filter.visible" class="items-start mt-3 text-left">
          <span class="text-left text-2xl font-semibold text-zinc-900 dark:text-white">
            {{ $t(filterName) }}
          </span>

          <ul class="space-y-2 md:space-y-0 text-sm mt-2 md:mt-0">
            <li
              class="flex items-start justify-between"
              v-for="(item, index) in showAllFilters[filterName] ? filter['filters'] : filter['filters'].slice(0, 5)"
              :key="index"
              :class="{ 'opacity-50 pointer-events-none': item.value === 0 && !selectedFilters.includes(item.key) }"
            >
              <div class="flex items-center">
                <input
                  :id="item.key"
                  type="checkbox"
                  :checked="selectedFilters.includes(item.key)"
                  @change="toggleFilters(item.key)"
                  class="custom-checkbox"
                  :disabled="item.value === 0 && !selectedFilters.includes(item.key)"
                />
                <label :for="item.id" class="ml-2 text-lg text-gray-900 dark:text-gray-100 line-clamp-1 text-left">
                  {{ item.label }}
                </label>
              </div>

              <label :for="item.id" class="ml-2 text-lg font-medium text-gray-500 dark:text-gray-300">
                ({{ item.value }})
              </label>
            </li>
          </ul>

          <button
            v-if="filter['filters'].length > 5"
            @click="toggleShowAll(filterName)"
            class="mt-2 text-Tourscanner_blue-source hover:text-blue-800 text-sm font-medium flex items-center"
          >
            {{ showAllFilters[filterName] ? $t('Show less') : $t('Show more') }}
          </button>
        </div>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { reactive } from 'vue';

function toggleFilters(key) {
  props.filterSelectedCallback(key);
}

const showAllFilters = reactive({});

function toggleShowAll(filterName) {
  showAllFilters[filterName] = !showAllFilters[filterName];
}

const props = defineProps({
  filtersData: {
    type: Object,
    required: true,
  },
  filterSelectedCallback: {
    type: Function,
    required: true,
  },
  selectedFilters: {
    type: Array,
    required: true,
  },
});

// Initialize showAllFilters
for (const filterName in props.filtersData) {
  showAllFilters[filterName] = false;
}
</script>

<script>
export default {
  computed: {
    buttonClasses() {
      return `
        text-white bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300
        font-medium rounded-lg text-sm px-4 py-2.5 text-center inline-flex items-center
        dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800
      `;
    },
    dropdownClasses() {
      return `
        z-10 w-56 p-3 bg-white rounded-lg shadow dark:bg-gray-700
      `;
    },
    checkboxClasses() {
      return `
        w-8 h-8 md:w-4 md:h-4 bg-gray-100 border-gray-300 text-primary-600 focus:ring-primary-500 dark:focus:ring-primary-600
        dark:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500
      `;
    },
  },
};
</script>

<style scoped>
.custom-checkbox {
  border-radius: 4px;
  width: 24px;
  height: 24px;
  background-color: #f3f4f6;
  border: 1px solid #d1d5db;
  appearance: none;
  cursor: pointer;
  position: relative;
  flex-shrink: 0;
}

.custom-checkbox:checked {
  background-color: #004f7b;
  border-color: #0ea5e9;
}

.custom-checkbox:checked::after {
  content: '\2713';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 14px;
  font-weight: 600;
  color: white;
}

.custom-checkbox:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

@media (min-width: 768px) {
  .custom-checkbox {
    width: 20px;
    height: 20px;
  }
}
</style>
